import http from './http'

export async function register({ username, firstName, lastName, email, phone, password }) {
  const payload = { userName: username, firstName, surname: lastName, email, password, phoneNumber: phone }
  const { data } = await http.post('/api/account/register', payload)
  return data
}

function decodeJwt(token) {
  try {
    const [, payload] = token.split('.')
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
  } catch { return null }
}

export async function login({ email, username, password }) {
  const usernameOrEmail = email || username

  const { data } = await http.post('/api/account/login', { usernameOrEmail, password })
  const token = data?.token || data?.accessToken || data?.jwt
  if (!token) throw new Error('Token manquant')

  localStorage.setItem('token', token)

  let me = null
  try {
    const res = await http.get('/api/account/me')
    me = res.data
  } catch {
    const p = decodeJwt(token)
    me = p ? {
      id: p.nameid || p.sub,
      email: p.email || p.unique_name,
      firstName: p.given_name || p.givenName,
      lastName: p.family_name || p.surname || p.lastName,
      username: p.username || p.name || usernameOrEmail,
      profileImageUrl: p.profileImageUrl || null,
      phoneNumber: p.phone_number || null,
    } : { username: usernameOrEmail }
  }

  localStorage.setItem('user', JSON.stringify(me))
  return { token, user: me }
}

export function logout() {
  localStorage.removeItem('token')
}
